// extracted by mini-css-extract-plugin
export default {"productGallery":"FI-z","inQuickShop":"GI-z"};